import { render, staticRenderFns } from "./RequestDetailsInfo.vue?vue&type=template&id=0ed9bd8e&scoped=true"
import script from "./RequestDetailsInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestDetailsInfo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RequestDetailsInfo.vue?vue&type=style&index=0&id=0ed9bd8e&prod&scoped=true&lang=css"
import style1 from "./RequestDetailsInfo.vue?vue&type=style&index=1&id=0ed9bd8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed9bd8e",
  null
  
)

export default component.exports